import { useState, useEffect } from 'react';
import { getAssetsNames } from '../../lib/supabase';
import { AssetsList } from './AssetsList';

interface AssetsListWithNamesProps {
  assets: {
    players?: number[];
    picks?: number[];
    goalies?: number[];
  };
  compact?: boolean;
}

export function AssetsListWithNames({ assets, compact = false }: AssetsListWithNamesProps) {
  const [playerNames, setPlayerNames] = useState<{ [key: number]: string }>({});
  const [pickDetails, setPickDetails] = useState<{ [key: number]: { round: number; year: number; description?: string } }>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNames = async () => {
      if (!assets || (!assets.players?.length && !assets.goalies?.length && !assets.picks?.length)) {
        setLoading(false);
        return;
      }

      try {
        const names = await getAssetsNames(assets);
        setPlayerNames(names.playerNames);
        setPickDetails(names.pickDetails);
      } catch (error) {
        console.error('Error fetching asset names:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchNames();
  }, [assets]);

  if (loading) {
    return (
      <div className="text-sm opacity-60 flex items-center gap-2">
        <span className="loading loading-spinner loading-xs"></span>
        Chargement...
      </div>
    );
  }

  return (
    <AssetsList 
      assets={assets} 
      compact={compact}
      playerNames={playerNames}
      pickDetails={pickDetails}
    />
  );
}